<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-light
				span.fa.fa-search.mr-2
				| Búsqueda
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
						.form-group
							label
								b Agente
							input.form-control.form-control-sm(v-model="filtro.agente", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
						.form-group
							label
								b Cliente
							input.form-control.form-control-sm(v-model="filtro.cliente", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
						.form-group
							label
								b Título del contrato
							input.form-control.form-control-sm(v-model="filtro.contrato", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
			.card-footer
				button.m-1.btn.btn-sm.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
				button.m-1.btn.btn-sm.btn-dark(@click="nueva")
					span.fa.fa-search.mr-2
					| Nueva radiación
		
		Resultados(:resultados="resultados")

</template>


<script>
import Resultados from './resultados'
export default {
	components: {
		Resultados
	},
	data () {
		return {
			filtro: {
				agente: null,
				cliente: null,
				contrato: null
			},
			resultados: []
		}
	},
	methods: {
		buscar () {
			console.log('Buscamos')
		},
		nueva () {
			this.$router.push('/main/radiacion/nueva')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/listado/listado.vue